import React from "react";
import { format } from "date-fns";
import { Alert, Text } from "@networkraildigitalfactory/components";
import ObjectiveInfo from "../ViewObjectiveData/ObjectiveInfo";
import useUser from "../../hooks/useUser";

const ViewPdpData = (props) => {
  const {
    name,
    currentFeedback,
    dueDate,
    value,
    developmentGoal,
    actionPlan,
    status,
    auditHistory,
  } = props.data;

  const { user, isLineManager, employeeBeingViewed } = props;
  const { isGBR: isGBREmployee } = useUser(employeeBeingViewed?.email);
  const dueDateChecked = dueDate === null ? "" : format(new Date(dueDate), "dd/MM/yyyy");
  const getFeedbackTitle = () => {
    let title = "Your ";
    if (auditHistory && auditHistory.length > 1) {
      const createdBy = auditHistory[auditHistory.length - 1].user;
      if (createdBy !== user.email) {
        title = "Line manager's ";
        if (isLineManager) {
          if (createdBy === employeeBeingViewed.email) {
            title = "Employee's ";
          } else if (createdBy === employeeBeingViewed.additionalLM) {
            title = "Additional manager's ";
          }
        }
      }
    }
    const reason = status === "cancelled" ? "cancellation reason" : "feedback";
    return title + reason;
  };
  return (
    <>
      <Text
        wrapper="h2"
        type="header"
        style={{ margin: "1.5rem 0", lineHeight: "140%", letterSpacing: "0.0015em" }}
      >
        {name}
      </Text>
      {currentFeedback && <Alert title={getFeedbackTitle()} message={currentFeedback} />}
      <ObjectiveInfo label="Due date" answer={dueDateChecked} wrapper="span" />
      <ObjectiveInfo
        label={isGBREmployee ? "GBRTT behaviour" : "Network Rail Vision Statement"}
        answer={value}
        wrapper="span"
      />
      <ObjectiveInfo label="Please describe your development goal" answer={developmentGoal} />
      <ObjectiveInfo
        label="What’s your action plan? How will you achieve this?"
        answer={actionPlan}
      />
    </>
  );
};

export default ViewPdpData;
